import "./style.css";
import {useEffect} from "react";

export default function Toast(props: any) {
    useEffect(() => {
        const timer = setTimeout(() => props.onClose(), 3000);
        return () => clearTimeout(timer);
    }, [props.onClose]);

    return (
        <div className="toast-text-box">
            <div className="text">
                {props.message}
            </div>
        </div>
    );
}